import Vue from 'vue';

function pad(num) {
  return (`0${num}`).slice(-2);
}

Vue.mixin({
  methods: {
    pad,
    timestamp(val) {
      if (typeof val.getTime === 'function') {
        return val.getTime();
      }
      return parseInt(`${val}000`.substr(0, `${(new Date()).getTime()}`.length), 10);
    },
    date(val) {
      if (!val) return '';

      const date = new Date(this.timestamp(val));
      const y = date.getFullYear();
      const m = pad(date.getMonth() + 1);
      const d = pad(date.getDate());

      return `${y}-${m}-${d}`;
    },
    jdateNoEuropeanYear(val) {
      if (!val) return '';

      const date = new Date(this.timestamp(val));
      const y = date.getFullYear();
      const m = pad(date.getMonth() + 1);
      const d = pad(date.getDate());

      return `${this.calcYear(y)}${m}月${d}日`;
    },
    jdate(val) {
      if (!val) return '';

      const date = new Date(this.timestamp(val));
      const y = date.getFullYear();
      const m = pad(date.getMonth() + 1);
      const d = pad(date.getDate());

      return `${this.calcYear(y)}${m}月${d}日 (${y})`;
    },
    jdateMonth(val) {
      if (!val) return '';

      const date = new Date(this.timestamp(val));
      const y = date.getFullYear();
      const m = pad(date.getMonth() + 1);

      return `${this.calcYear(y)}${m}月`;
    },
    jYear(year) {
      if (!year) return '';

      return `${this.calcYear(year)}(${year})`;
    },
    calcYear(year) {
      if (year <= 1988) return `昭和${year - 1925}年`;
      if (year <= 2018) return `平成${parseInt(year, 10) === 1989 ? '元' : year - 1988}年`;
      return `令和${parseInt(year, 10) === 2019 ? '元' : year - 2018}年`;
    },
    jdateShort(val, weekday) {
      const date = new Date(this.timestamp(val));
      const wd = weekday === false
        ? ''
        : `(${date.toLocaleDateString('ja', { weekday: 'narrow' })}) `;

      return `${date.getMonth() + 1}月${date.getDate()}日 ${wd}`;
    },
    hour(val) {
      const date = new Date(this.timestamp(val));
      return pad(date.getHours());
    },
    time(val, seconds) {
      const date = new Date(this.timestamp(val));
      const h = pad(date.getHours());
      const m = pad(date.getMinutes());
      const s = seconds ? `:${pad(date.getSeconds())}` : '';

      return `${h}:${m}${s}`;
    },
    num(value) {
      return value ? parseInt((`${value}`).replace(/[^0-9]/g, '') || 0, 10) : 0;
    },
    amount(number) {
      return `${this.num(number)}`.replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1,');
    },
    money(price) {
      return `${this.moneyPlain(price)}万`;
    },
    moneyPlain(price = 0) {
      return Math.round((price / 10000) * 10) / 10;
    },
    plain(number = 0) {
      return this.amount(number);
    },
    cut(str, length, mode) {
      if (!str) {
        return '';
      }
      if (!length || length >= str.length) {
        return str;
      }

      const start = str.substr(0, length / 2);
      const end = str.substr(str.length - Math.ceil(length / 2), Math.ceil(length / 2));

      switch (mode) {
        case 'right':
          return `...${str.substr(str.length - length, length)}`;
        case 'middle':
          return `${start}...${end}`;
        case 'left':
        default:
          return `${str.substr(0, length)}...`;
      }
    },
  },
});



// WEBPACK FOOTER //
// ./src/plugins/format.js